import React, { useState, useEffect } from "react";
import "./../../../assets/css/purchase/form.css";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";

// Utils
import { formatDateOnChange, formatStringDateToDate } from "../../../utils/DateUtils";
import { getAlert, getDataWithComp } from "../../../utils/SamuiUtils";

const InventoryMovementReport = () => {
    // ตัวแปรเก็บชื่อหน้าจอ
    const [name, setName] = useState(null);

    // ตัวแปรเก็บค่าเงื่อนไขการค้นหา
    const [searchCriteria, setSearchCriteria] = useState([]);

    // ข้อมูลที่แสดงรายงาน
    const [filteredData, setFilteredData] = useState([]);

    // สำหรับ Table รายงาน
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(16);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async () => {
        // เริ่มต้นหน้าจอ (เปิดครั้งแรก)
        setName("2.1 รายงาน Inventory Movement (แยกตามแผนก/คลัง)");
        setSearchCriteria(
            {
                stcDate: formatDateOnChange(new Date()),
                whCode: null,
                whName: null
            }
        );
        setFilteredData([]);
    };

    const handleChangeCriteria = (e) => {
        const { name, value } = e.target;
        setSearchCriteria((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleChangeDate = (value, name) => {
        const newValue =
            value && value instanceof moment ? value.format("YYYY-MM-DD") : value;
        setSearchCriteria((prev) => ({
            ...prev,
            [name]: formatDateOnChange(newValue),
        }));
    };

    const handleSearch = async () => {
        try {
            setFilteredData([]);

            let query = '';

            if (searchCriteria.stcDate) {
                const formattedDate = formatStringDateToDate(searchCriteria.stcDate).split(' ')[0];
                query += `AND CONVERT(DATE, STC_Date) = '${formattedDate}' `;
            }

            if (searchCriteria.whCode) {
                query += `AND WH_Code = '${searchCriteria.whCode}' `;
            }
            if (searchCriteria.whName) {
                query += `AND WH_Name = '${searchCriteria.whName}' `;
            }

            const response = await getDataWithComp('API_1201_WH_ITEM_STC', query.trim());

            if (response && response.length > 0) {
                setFilteredData(response);
            }
        } catch (error) {
            getAlert("FAILED", error.response?.message || error.message);
        }
    };

    return (
        <>
            <Sidebar />
            <div className="main-panel">
                <div className="container">
                    <div className="page-inner">
                        <div className="page-header d-flex justify-content-between align-items-center">
                            <Breadcrumbs
                                page={name}
                                items={[
                                    { name: "รายงาน", url: "/reports" },
                                    { name: name, url: "/inventory-movement-report" },
                                ]}
                            />
                        </div>
                        <div className="row">
                            {/* Criteria */}
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4>เงื่อนไขการค้นหา</h4>
                                    </div>
                                    <div className="card-body">
                                        <form className="row g-3">
                                            <div className="col-md-2">
                                                <label htmlFor="stcDate" className="form-label">ช่วงวันที่</label>
                                                <Datetime
                                                    id="stcDate"
                                                    className="input-spacing-input-date"
                                                    value={searchCriteria.stcDate}
                                                    dateFormat="DD-MM-YYYY"
                                                    timeFormat={false}
                                                    onChange={(date) => handleChangeDate(date, "stcDate")}
                                                    inputProps={{ readOnly: true, disabled: false }}

                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="whCode" className="form-label">รหัสคลัง</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-spacing"
                                                    id="whCode"
                                                    name="whCode"
                                                    value={searchCriteria.whCode || ""}
                                                    onChange={handleChangeCriteria}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label htmlFor="whName" className="form-label">ชื่อคลัง</label>
                                                <input
                                                    type="text"
                                                    className="form-control input-spacing"
                                                    id="whName"
                                                    name="whName"
                                                    value={searchCriteria.whName || ""}
                                                    onChange={handleChangeCriteria}
                                                />
                                            </div>
                                            <div className="col-md-4"></div>
                                            <div className="col-md-12 d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ width: '10%', marginRight: '20px', backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={() => handleSearch()}
                                                >
                                                    <i className="fas fa-search" /> ค้นหา
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ width: '10%', backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={() => initialize()}
                                                >
                                                    <i className="fas fa-undo" /> เริ่มใหม่
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            {/* ReportsTable */}
                            <ReportsTable
                                currentItems={currentItems}
                                currentPage={currentPage}
                                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                                dataMasterList={filteredData}
                                itemsPerPage={itemsPerPage}
                                fieldMappings={{
                                    stcDate: 'STC_Date',
                                    itemCode: 'Item_Code',
                                    itemName: 'Item_Name',
                                    docType: 'Doc_Type',
                                    stcQty: 'STC_QTY',
                                    docNo: 'Doc_No',
                                    docNoRef: 'Doc_NoRef',
                                    stcRemark: 'STC_Remark'
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default InventoryMovementReport;